import { render, staticRenderFns } from "./RecommendationsPhysicalComp.vue?vue&type=template&id=16c4c6ac&scoped=true"
import script from "./RecommendationsPhysicalComp.vue?vue&type=script&lang=js"
export * from "./RecommendationsPhysicalComp.vue?vue&type=script&lang=js"
import style0 from "./RecommendationsPhysicalComp.vue?vue&type=style&index=0&id=16c4c6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c4c6ac",
  null
  
)

/* custom blocks */
import block0 from "./RecommendationsPhysicalComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports